import React, { Component } from 'react';
import config from 'react-global-configuration';
import configuration from './config';
import $ from 'jquery';
import Header  from './header/Header';
import Main  from './Main';
import Footer  from './footer/Footer';
import Helmet from 'react-helmet';
import Subscribe from './footer/subscribe/Subscribe';
import logo from './logo.svg';
import './App.css';
import currency_schema from './service/schema/currency-scema';

class App extends Component {
    constructor(props) {
        super(props);
        //config.set(configuration);

    }
    render() {

    return (
        <div>

            <Header />
            <Main />
            {/*Footer*/}
            <Subscribe />
            <Footer />
        </div>
    
    );
  }
    onload() {
        var a = $('.fx').innerHeight();
        function hgt(){
            $('header').css('min-height', '150px');
        }
        $(window).scroll(function(){

            var xs = $('#xf');
            var b = $('.fx').offset();
            var scroll = $(window).scrollTop();
            if(scroll >= 100){
                $('.navbar').hide();
                $('#head-mini').addClass('nav-mini-pad');
                $('#head-advs').hide();
                $('#auto_reports').css('height','25px');
                $('#head-sbtn').css({'height':'32px', 'padding-top':'5px'});
                $('#head-sdiv').css('margin-top','5px');
                xs.removeClass('pad-15');
                $('#logi').attr("src",'https://mordorintelligence.com:81/mordorlabs/img/home_image/logo.png');
            }
            else{
                $('.navbar').show();
                $('#head-mini').removeClass('nav-mini-pad');
                $('#head-advs').show();
                $('#auto_reports').css('height','49px');
                $('#head-sbtn').css({'height':'49px', 'padding-top':'15px'});
                $('#head-sdiv').css('margin-top','0px');
                xs.addClass('pad-15');
                $('#logi').attr("src",'https://mordorintelligence.com:81/mordorlabs/img/home_image/mordor_logo.png')
            }
            hgt();

        });
        $(document).ready(function(){
            $('#d').fadeOut();

        });
        hgt();
    };
    componentDidMount(){
        this.onload();
        this.callCurrencyFun()
    }
    callCurrencyFun() {
       if(!currency_schema.isCall)
       {
           this.getCurrencyUpdate()
           localStorage.setItem('latest_cuurency','usd');
       }


    }
    getCurrencyUpdate() {
        let url = 'https://api.fixer.io/latest?base=USD&symbols=USD,GBP,INR,EUR,JPY';
        fetch(url)
            .then(res => res.json())
            .then(
                (result) => {

                    currency_schema.data = result;
                    currency_schema.isCall = true;
                },
                (error) => {

                }
            )
    }
                        }

export default App;



// WEBPACK FOOTER //
// ./src/App.js